import React from "react";
import s from './error-message.module.scss';
import {FontIcon} from "../FontIcon";
import {logger} from "../../../services/log/logger";
import {useAppSelector} from "../../../redux/hooks";
import {commonStore} from "../../../redux/common/commonStore";
import {GenericModal} from "../genericModal/GenericModal";
import Container from "../tools/Container/Container";

export default function ErrorMessage() {
  const error = useAppSelector(commonStore.getError);
  if(!error.isOpen) {
    return null;
  }
  const message = error.message;
  const formattedTimestamp = error.timestamp
    ? new Date(error.timestamp).toLocaleString(undefined, {
        month: "numeric",
        day: "numeric",
        year: "numeric",
        hour: "numeric",
        minute: "2-digit",
        second: "2-digit",
        timeZoneName: "short",
      })
    : null;
  let debugInfo = error.debugInfo || [];
  debugInfo = Array.isArray(debugInfo) ? debugInfo : [debugInfo];
  const debugInfoString = debugInfo.join("<br/>");

  // convert debugInfo to { key: string; value: any; }[]
  let index = 1;
  const data = [];
  for (const info of debugInfo) {
    data.push({ key: `detail-#${index}`, value: info.toString() });
    index++;
  }

  logger.warn({
    message: `ERRORMESSAGE`,
    additionalNote: message,
    data: data,
  });

  return (
    <GenericModal
      canShow={(): boolean => {
        return true;
      }}
      backgroundColor={"white"}
      title={"Error"}
      maxWidth={"350px"}
      onClose={() => {
        commonStore.hideError();
      }}
    >
      <div className={s.container}>
        <div className={s.fontIconWrapper}>
          <FontIcon icon={"icon-exclamation-triangle"}/>
        </div>
        <div className={s.messageText}>
          {message ?? "An unexpected error has occurred."}
        </div>

        {formattedTimestamp && <div className={s.timestamp}>{formattedTimestamp}</div>}

        {debugInfo.length === 0
          ? null
          :
          <Container textAlign={"left"} isCollapsible={true} label={"Details"} isInitiallyCollapsed={true}>
            <div dangerouslySetInnerHTML={{__html: debugInfoString}} />
          </Container>
        }
      </div>
    </GenericModal>
  );
}
